import React from "react";
import moment from 'moment';
import context from "../../lib/context.js";
import { browserHistory } from "react-router";
import ajax from "./../../lib/ajax.js";
import Iframe from 'react-iframe';
import Paginator from "./../shared/paginator.jsx";


export default class PaystubGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paystubs: [],
            issueDateSort: 1,
            paymethodSort: 0,
            pageSize:10

        };
        this.sortByParam = this.sortByParam.bind(this);
        this.onPaystubDetailClick = this.onPaystubDetailClick.bind(this);
        this.compare = this.compare.bind(this);
    }
    sortByParam(param) {
        let self = this;
        let list = self.state.paystubs;
        let order = '';
        if (param === 'issueDate') {
            order = self.state.issueDateSort === 1 ? 'asc' : 'dsc';
        } else {
            order = self.state.paymethodSort === 1 ? 'asc' : 'dsc';
        }
        if (list.length > 1) {
            if (order === 'asc') {
                let found = false
                for (let i = 0; i < list.length; i++) {
                    found = false;
                    for (let j = 0; j < list.length - i - 1; j++) {
                        if (this.compare(param, list[j], list[j + 1]) === 1) {
                            let t = list[j];
                            list[j] = list[j + 1];
                            list[j + 1] = t;
                            found = true;
                        }
                    }
                    if (!found) break;
                }
            } else {
                let found = false;
                for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < list.length - i - 1; j++) {
                        found = false;
                        if (this.compare(param, list[j], list[j + 1]) === -1) {
                            let t = list[j];
                            list[j] = list[j + 1];
                            list[j + 1] = t;
                            found = true;
                        }
                    }
                    if (!found) break;
                }
            }
        }
        if (param === 'issueDate') {
            let o = order === 'asc' ? 0 : 1;
            
            self.setState({
                paystubs: list,
                issueDateSort: o,
                paymethodSort: 0,
            });
        }
        if (param === 'paymentMethod') {
            let o = order === 'asc' ? 0 : 1;
            self.setState({
                paystubs: list,
                paymethodSort: o,
                issueDateSort: 0,
            });
        }

    }
    compare(param, obj1, obj2) {
        if (param === 'issueDate') {
            let d1 = moment(obj1.issueDate);
            let d2 = moment(obj2.issueDate);
            return moment.duration(d1.diff(d2)).asDays() > 0 ? 1 : -1;
        } else {
            return (obj1.paymentMethod.length > obj2.paymentMethod.length) ? 1 : -1;
        }
    }
    componentWillReceiveProps(nextProps) {

        this.setState({
            paystubs:nextProps.paystubs,
            issueDateSort: 1,
            paymethodSort: 0,
        });
    }
    onPaystubDetailClick(id) {
        if (this.props.onPaystubDetailClick) this.props.onPaystubDetailClick(id);
    }

    render() {
        let content = [];
        let self = this;
        let paystubs = self.state.paystubs;

        let numPages = (paystubs.length / this.state.pageSize) + (paystubs.length % this.state.pageSize > 0 ? 1 : 0);
        if (paystubs.length === 0) {
            return (
                <div className="col-md-12 ap-paystubgrid-empty">
                    No Pay Statements found !
                </div>
            );
        } else {
               let lower = this.props.startIndex;
               let upper = paystubs.length < this.props.endIndex  ? paystubs.length : this.props.endIndex;
            for (let i = lower; i < upper; i++) {
                let p = paystubs[i];
                content.push(
                    <div className="row ap-paystubgrid-detail" key={p.id}>
                        <div className="col-md-3">
                            {moment(p.issueDate).format('MM/DD/YYYY')}
                        </div>
                        <div className="col-md-3">
                            {p.paymentMethod}
                        </div>
                        <div className="col-md-3">
                            {p.checkNumber}
                        </div>
                        <div className="col-md-3">                       
                            <a onClick={() => this.onPaystubDetailClick(p.id)} className="fa fa-file-text ap-pointer"></a>
                        </div>
                    </div>
                );
            }
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-paystubgrid-header">
                            <div className="row">
                                <div className="col-md-3">
                                    Issue Date <span className={self.state.issueDateSort === 1 ? "fa fa-sort-desc ap-color-black ap-pointer" : "fa fa-sort-desc ap-pointer"}
                                        onClick={() => { this.sortByParam('issueDate'); }} />
                                </div>
                                <div className="col-md-3">
                                    Payment Method <span className={self.state.paymethodSort === 1 ? "fa fa-sort-desc ap-color-black ap-pointer" : "fa fa-sort-desc ap-pointer"}
                                        onClick={() => { this.sortByParam('paymentMethod'); }}></span>
                                </div>
                                <div className="col-md-3">
                                    Check Number
                            </div>
                                <div className="col-md-3">
                                    Details
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ap-paystubgrid container-fluid">
                            {content}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={numPages} range="3" selectedIndex={this.props.currentIndex} onNavigate={this.props.onNavigate}/>
                    </div>
                </div>
            </div>
        );
    }
}